import React from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import SellerWebsiteLink from './components/SellerWebsiteLink';

import { TListingClient } from 'types/TListing';

type TDescriptionSellerWebsiteLinkAppProps = {
  appState: {
    listing: {
      seller: TListingClient['seller'];
    };
  };
  environment: any;
};

const DescriptionSellerWebsiteLinkApp = ({ appState, environment }: TDescriptionSellerWebsiteLinkAppProps) => {
  const {
    listing: { seller },
  } = appState;
  return (
    <EnvironmentProvider value={environment}>
      <SellerWebsiteLink seller={seller} />
    </EnvironmentProvider>
  );
};

export default DescriptionSellerWebsiteLinkApp;
